import { isNative, SDK_VERSION, isMobile, envRegion } from '../constants';
import { getFp, getOs } from '../utils';
const slardarPromise = import(
  /* webpackChunkName: "sld" */
  /* webpackMode: "lazy" */ process.env.SLARDAR_NPM as string
);

let BrowserSlardar: null | any = null;

function singleBrowserSlardar() {
  return (async () => {
    if (!BrowserSlardar) {
      const { createBrowserClient } = await slardarPromise;
      BrowserSlardar = createBrowserClient();
    }
    return BrowserSlardar;
  })();
}

export const init = async (options: IObj) => {
  try {
    if (BrowserSlardar) return;
    const _BrowserSlardar = await singleBrowserSlardar();
    const slardarParams = {
      fp: isNative ? '' : getFp(),
      did: options.did || '',
      h5_sdk_version: SDK_VERSION,
      os_name: isNative ? options.os_name || '' : getOs(),
      platform: isNative ? 'app' : isMobile ? 'h5' : 'pc',
    };
    _BrowserSlardar.context?.merge(slardarParams);
    const config: any = {
      bid: 'oec_verify_center',
      pid: options.aid + '' || '0',
      release: SDK_VERSION,
      env:
        process.env.NODE_ENV === 'development'
          ? 'development'
          : process.env.REGION_ENV,
    };
    _BrowserSlardar.init(config);
  } catch (error) {}
};

export const start = async () => {
  try {
    singleBrowserSlardar().then((BrowserSlardar) => {
      BrowserSlardar.start();
    });
  } catch (error) {}
};

export const close = () => {
  try {
    singleBrowserSlardar().then((BrowserSlardar) => {
      BrowserSlardar.destroy();
    });
  } catch (error) {}
};
